module.exports = __webpack_public_path__ + "static/img/GPTplant.be06cd90.png";